import {ClickerGCSEngine} from '@/ui/pages/ClickerGamePage/clicker-game/ClickerGame.types';
import {Point} from 'pixi.js';

import {Factory, token} from 'brandi';

import {HealthComponent, Movement2dComponent, Transform2dComponent} from '@specials/gcs-engine';

import {PixiRenderer} from '@/gcs/PixiRenderer';
import {PixiViewRendererComponent} from '@/gcs/PixiViewRendererComponent';

export const GCS_TOKENS = {
  // gcs
  gcsEngine: token<ClickerGCSEngine>('gcsEngine'),

  // components
  healthComponent: token<HealthComponent>('healthComponent'),

  movement2dComponent: token<Movement2dComponent>('movement2dComponent'),
  transform2dComponent: token<Transform2dComponent>('transform2dComponent'),
  transform2dComponentFactory: token<Factory<Transform2dComponent>>('transform2dComponentFactory'),

  pixiRenderer: token<PixiRenderer>('pixiRenderer'),
  pixiViewRendererComponent: token<PixiViewRendererComponent>('PixiViewRendererComponent'),

  pointFactory: token<Factory<Point, [x: number, y: number]>>('pointFactory'),
};
